import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
export function TermsRestaurantsPage() {
  return <div className="min-h-screen bg-[#0B0B0B] text-white selection:bg-[#006847] selection:text-white" data-id="element-8040">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#0B0B0B]/80 backdrop-blur-md border-b border-white/10" data-id="element-8041">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-8042">
          <Link to="/" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm font-medium" data-id="element-8043">
            <ArrowLeft className="w-4 h-4" data-id="element-8044" />
            Volver
          </Link>
          <div className="font-black text-xl tracking-tight" data-id="element-8045">NOIZA</div>
          <div className="w-20" data-id="element-8046" /> {/* Spacer for centering */}
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12 md:py-20" data-id="element-8047">
        <div className="mb-12" data-id="element-8048">
          <div className="w-12 h-12 bg-white/5 rounded-2xl flex items-center justify-center mb-6 border border-white/10" data-id="element-8049">
            <FileText className="w-6 h-6 text-white/80" data-id="element-8050" />
          </div>
          <h1 className="text-3xl md:text-4xl font-black mb-4 tracking-tight" data-id="element-8051">
            Términos y Condiciones para Restaurantes
          </h1>
          <p className="text-white/60 text-lg" data-id="element-8052">
            NOIZA – Plataforma Tecnológica y Marketplace Gastronómico
          </p>
        </div>

        <div className="space-y-12 text-white/80 leading-relaxed" data-id="element-8053">
          <section data-id="element-8054">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8055">
              <span className="text-[#006847]" data-id="element-8056">1.</span>
              INTRODUCCIÓN Y ACEPTACIÓN
            </h2>
            <div className="space-y-4" data-id="element-8057">
              <p data-id="element-8058">
                Los presentes Términos y Condiciones regulan el acceso, uso y
                permanencia del restaurante dentro de la plataforma NOIZA, en
                adelante "la Plataforma".
              </p>
              <p data-id="element-8059">
                Al registrarse, acceder o utilizar cualquier funcionalidad de
                NOIZA, el restaurante declara:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8060">
                <li data-id="element-8061">Haber leído íntegramente este documento</li>
                <li data-id="element-8062">Comprender su contenido en su totalidad</li>
                <li data-id="element-8063">
                  Aceptar voluntaria e irrevocablemente todas sus condiciones
                </li>
              </ul>
              <p data-id="element-8064">
                En caso de no estar de acuerdo con alguno de los puntos
                establecidos, el restaurante deberá abstenerse de utilizar la
                Plataforma.
              </p>
            </div>
          </section>

          <section data-id="element-8065">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8066">
              <span className="text-[#006847]" data-id="element-8067">2.</span>
              NATURALEZA DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-8068">
              <p data-id="element-8069">NOIZA es una solución tecnológica que combina:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8070">
                <li data-id="element-8071">Software como servicio (SaaS)</li>
                <li data-id="element-8072">Marketplace digital gastronómico</li>
                <li data-id="element-8073">Herramientas de gestión operativa para restaurantes</li>
              </ul>
              <p data-id="element-8074">La Plataforma permite a los restaurantes:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8075">
                <li data-id="element-8076">Mostrar su menú digital</li>
                <li data-id="element-8077">Recibir pedidos de clientes</li>
                <li data-id="element-8078">Gestionar su operación interna</li>
                <li data-id="element-8079">
                  Facilitar la comunicación directa con el cliente
                  (principalmente vía WhatsApp)
                </li>
              </ul>
              <p className="font-medium text-white" data-id="element-8080">
                NOIZA actúa únicamente como un facilitador tecnológico.
              </p>
            </div>
          </section>

          <section data-id="element-8081">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8082">
              <span className="text-[#006847]" data-id="element-8083">3.</span>
              DECLARACIÓN EXPRESA DE NO INTERMEDIACIÓN
            </h2>
            <div className="space-y-4" data-id="element-8084">
              <p data-id="element-8085">El restaurante reconoce expresamente que NOIZA:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8086">
                <li data-id="element-8087">No es proveedor de alimentos</li>
                <li data-id="element-8088">No participa en la preparación de productos</li>
                <li data-id="element-8089">No manipula alimentos en ningún momento</li>
                <li data-id="element-8090">No realiza entregas ni logística</li>
                <li data-id="element-8091">No procesa pagos en nombre del restaurante</li>
                <li data-id="element-8092">No actúa como representante comercial del restaurante</li>
              </ul>
              <p data-id="element-8093">
                La Plataforma se limita a proporcionar herramientas digitales
                para facilitar la interacción entre el restaurante y el cliente
                final.
              </p>
            </div>
          </section>

          <section data-id="element-8094">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8095">
              <span className="text-[#006847]" data-id="element-8096">4.</span>
              INDEPENDENCIA DEL RESTAURANTE
            </h2>
            <div className="space-y-4" data-id="element-8097">
              <p data-id="element-8098">
                Cada restaurante que utiliza NOIZA opera como una entidad
                completamente independiente.
              </p>
              <p data-id="element-8099">Esto implica que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8100">
                <li data-id="element-8101">El restaurante es el único responsable de su operación</li>
                <li data-id="element-8102">
                  No existe relación laboral, societaria o de representación con
                  NOIZA
                </li>
                <li data-id="element-8103">
                  NOIZA no ejerce control sobre las decisiones del restaurante
                </li>
              </ul>
              <p data-id="element-8104">El restaurante mantiene total autonomía en:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8105">
                <li data-id="element-8106">Precios</li>
                <li data-id="element-8107">Menú</li>
                <li data-id="element-8108">Horarios</li>
                <li data-id="element-8109">Métodos de pago</li>
                <li data-id="element-8110">Procesos internos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8111">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8112">
              <span className="text-[#006847]" data-id="element-8113">5.</span>
              EXCLUSIÓN TOTAL DE RESPONSABILIDAD
            </h2>

            <div className="space-y-8" data-id="element-8114">
              <div data-id="element-8115">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8116">
                  5.1. Alcance general
                </h3>
                <p data-id="element-8117">
                  El restaurante acepta que NOIZA queda exento de cualquier tipo
                  de responsabilidad, directa o indirecta, derivada de la
                  operación del restaurante.
                </p>
              </div>

              <div data-id="element-8118">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8119">
                  5.2. Alimentos y calidad del servicio
                </h3>
                <p className="mb-2" data-id="element-8120">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-8121">
                  <li data-id="element-8122">Calidad de los alimentos</li>
                  <li data-id="element-8123">Estado, frescura o preparación</li>
                  <li data-id="element-8124">Ingredientes utilizados</li>
                  <li data-id="element-8125">Contaminación cruzada</li>
                  <li data-id="element-8126">Problemas de higiene o salubridad</li>
                  <li data-id="element-8127">Reacciones alérgicas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-8128">
                  Toda responsabilidad recae exclusivamente en el restaurante.
                </p>
              </div>

              <div data-id="element-8129">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8130">
                  5.3. Entregas y logística
                </h3>
                <p className="mb-2" data-id="element-8131">
                  NOIZA no participa ni interviene en la entrega de pedidos. Por
                  lo tanto, NOIZA no será responsable por:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8132">
                  <li data-id="element-8133">Retrasos en la entrega</li>
                  <li data-id="element-8134">Pérdida de pedidos</li>
                  <li data-id="element-8135">Entregas incompletas</li>
                  <li data-id="element-8136">Errores en dirección</li>
                  <li data-id="element-8137">Conducta de repartidores</li>
                  <li data-id="element-8138">Daños durante el transporte</li>
                </ul>
              </div>

              <div data-id="element-8139">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8140">
                  5.4. Pagos
                </h3>
                <p className="mb-2" data-id="element-8141">
                  NOIZA no procesa ni administra pagos. El restaurante es el
                  único responsable de:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-4" data-id="element-8142">
                  <li data-id="element-8143">Recepción de pagos</li>
                  <li data-id="element-8144">Validación de transferencias (incluyendo SINPE)</li>
                  <li data-id="element-8145">Manejo de efectivo</li>
                  <li data-id="element-8146">Confirmación de pagos</li>
                  <li data-id="element-8147">Prevención de fraudes</li>
                </ul>
                <p className="mb-2" data-id="element-8148">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8149">
                  <li data-id="element-8150">Pagos no recibidos</li>
                  <li data-id="element-8151">Comprobantes falsos</li>
                  <li data-id="element-8152">Errores en montos</li>
                  <li data-id="element-8153">Estafas o fraudes de terceros</li>
                </ul>
              </div>

              <div data-id="element-8154">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8155">
                  5.5. Relación con clientes
                </h3>
                <p className="mb-2" data-id="element-8156">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-8157">
                  <li data-id="element-8158">Reclamos de clientes</li>
                  <li data-id="element-8159">Reembolsos</li>
                  <li data-id="element-8160">Cancelaciones</li>
                  <li data-id="element-8161">Disputas</li>
                  <li data-id="element-8162">Opiniones o reseñas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-8163">
                  Toda relación comercial se da directamente entre el
                  restaurante y el cliente.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-8164">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8165">
              <span className="text-[#006847]" data-id="element-8166">6.</span>
              USO DE LA PLATAFORMA
            </h2>
            <div className="space-y-4" data-id="element-8167">
              <p data-id="element-8168">El restaurante se compromete a utilizar NOIZA de forma:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8169">
                <li data-id="element-8170">Responsable</li>
                <li data-id="element-8171">Legal</li>
                <li data-id="element-8172">Transparente</li>
              </ul>
              <p className="mt-4" data-id="element-8173">Queda prohibido:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8174">
                <li data-id="element-8175">Publicar información falsa</li>
                <li data-id="element-8176">Manipular precios de forma engañosa</li>
                <li data-id="element-8177">Simular disponibilidad inexistente</li>
                <li data-id="element-8178">Utilizar la plataforma con fines fraudulentos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8179">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8180">
              <span className="text-[#006847]" data-id="element-8181">7.</span>
              PROPIEDAD DEL MENÚ DIGITAL
            </h2>
            <div className="space-y-4" data-id="element-8182">
              <p data-id="element-8183">El menú digital creado dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8184">
                <li data-id="element-8185">Pertenece al restaurante en términos de contenido</li>
                <li data-id="element-8186">
                  Puede ser utilizado por el restaurante fuera del marketplace
                </li>
              </ul>
              <p className="mt-4 font-medium text-white" data-id="element-8187">Condiciones:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8188">
                <li data-id="element-8189">
                  Si el restaurante mantiene una suscripción activa, el sistema
                  opera normalmente
                </li>
                <li data-id="element-8190">
                  Si no mantiene suscripción:
                  <ul className="list-circle pl-6 mt-2 space-y-1" data-id="element-8191">
                    <li data-id="element-8192">
                      Podrá seguir utilizando el sistema únicamente si cubre
                      costos asociados (hosting, dominio, etc.)
                    </li>
                    <li data-id="element-8193">NOIZA podrá limitar funcionalidades</li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>

          <section data-id="element-8194">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8195">
              <span className="text-[#006847]" data-id="element-8196">8.</span>
              SISTEMA SaaS
            </h2>
            <div className="space-y-4" data-id="element-8197">
              <p data-id="element-8198">NOIZA proporciona un sistema tecnológico que incluye:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8199">
                <li data-id="element-8200">Menú digital</li>
                <li data-id="element-8201">Gestión de pedidos</li>
                <li data-id="element-8202">Herramientas operativas</li>
              </ul>
              <div className="grid sm:grid-cols-2 gap-6 mt-6" data-id="element-8203">
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-8204">
                  <p className="font-medium text-white mb-2" data-id="element-8205">
                    El restaurante recibe:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8206">
                    <li data-id="element-8207">Derecho de uso del sistema</li>
                  </ul>
                </div>
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-8208">
                  <p className="font-medium text-white mb-2" data-id="element-8209">NO recibe:</p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8210">
                    <li data-id="element-8211">Propiedad del software</li>
                    <li data-id="element-8212">Acceso al código fuente</li>
                  </ul>
                </div>
              </div>
              <p className="font-medium text-white mt-4" data-id="element-8213">
                NOIZA mantiene todos los derechos sobre la tecnología
                desarrollada.
              </p>
            </div>
          </section>

          <section data-id="element-8214">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8215">
              <span className="text-[#006847]" data-id="element-8216">9.</span>
              DISPONIBILIDAD DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-8217">
              <p data-id="element-8218">NOIZA no garantiza:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8219">
                <li data-id="element-8220">Disponibilidad continua</li>
                <li data-id="element-8221">Funcionamiento sin interrupciones</li>
                <li data-id="element-8222">Ausencia total de errores</li>
              </ul>
              <p className="mt-4" data-id="element-8223">Pueden ocurrir:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8224">
                <li data-id="element-8225">Fallas técnicas</li>
                <li data-id="element-8226">Actualizaciones</li>
                <li data-id="element-8227">Mantenimientos</li>
              </ul>
              <p className="font-medium text-white mt-2" data-id="element-8228">
                NOIZA no será responsable por pérdidas derivadas de estos
                eventos.
              </p>
            </div>
          </section>

          <section data-id="element-8229">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8230">
              <span className="text-[#006847]" data-id="element-8231">10.</span>
              VISIBILIDAD EN EL MARKETPLACE
            </h2>
            <div className="space-y-4" data-id="element-8232">
              <p data-id="element-8233">El restaurante acepta que su visibilidad dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8234">
                <li data-id="element-8235">No está garantizada permanentemente</li>
                <li data-id="element-8236">Puede variar según criterios internos</li>
              </ul>
              <p className="mt-4" data-id="element-8237">NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8238">
                <li data-id="element-8239">Destacar o no restaurantes</li>
                <li data-id="element-8240">Modificar posiciones</li>
                <li data-id="element-8241">Aplicar filtros o algoritmos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8242">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8243">
              <span className="text-[#006847]" data-id="element-8244">11.</span>
              PAGOS Y CONDICIONES ECONÓMICAS
            </h2>
            <div className="space-y-4" data-id="element-8245">
              <p data-id="element-8246">El restaurante se compromete a:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8247">
                <li data-id="element-8248">Cumplir con los pagos acordados</li>
                <li data-id="element-8249">Mantener su cuenta al día</li>
              </ul>
              <p className="mt-4" data-id="element-8250">En caso de incumplimiento, NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8251">
                <li data-id="element-8252">Suspender el servicio</li>
                <li data-id="element-8253">Limitar funcionalidades</li>
                <li data-id="element-8254">Retirar visibilidad</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8255">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8256">
              <span className="text-[#006847]" data-id="element-8257">12.</span>
              TERMINACIÓN
            </h2>
            <div className="space-y-4" data-id="element-8258">
              <p data-id="element-8259">NOIZA podrá suspender o terminar el acceso en caso de:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8260">
                <li data-id="element-8261">Incumplimiento de términos</li>
                <li data-id="element-8262">Uso indebido</li>
                <li data-id="element-8263">Conductas que afecten la plataforma</li>
              </ul>
              <p className="mt-2" data-id="element-8264">
                El restaurante podrá dejar de usar el servicio en cualquier
                momento.
              </p>
            </div>
          </section>

          <section data-id="element-8265">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8266">
              <span className="text-[#006847]" data-id="element-8267">13.</span>
              MODIFICACIONES
            </h2>
            <div className="space-y-4" data-id="element-8268">
              <p data-id="element-8269">NOIZA podrá modificar estos términos en cualquier momento.</p>
              <p data-id="element-8270">El uso continuo implica aceptación automática de cambios.</p>
            </div>
          </section>

          <section data-id="element-8271">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8272">
              <span className="text-[#006847]" data-id="element-8273">14.</span>
              LIMITACIÓN DE RESPONSABILIDAD
            </h2>
            <div className="space-y-4" data-id="element-8274">
              <p data-id="element-8275">En ningún caso NOIZA será responsable por:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8276">
                <li data-id="element-8277">Pérdidas económicas</li>
                <li data-id="element-8278">Daños indirectos</li>
                <li data-id="element-8279">Lucro cesante</li>
                <li data-id="element-8280">Daños reputacionales</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8281">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8282">
              <span className="text-[#006847]" data-id="element-8283">15.</span>
              LEGISLACIÓN APLICABLE
            </h2>
            <div className="space-y-4" data-id="element-8284">
              <p data-id="element-8285">
                Estos términos se regirán por la legislación aplicable en Costa
                Rica.
              </p>
            </div>
          </section>

          <section className="bg-white/5 p-6 rounded-2xl border border-white/10 mt-12" data-id="element-8286">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8287">
              <span className="text-[#006847]" data-id="element-8288">16.</span>
              ACEPTACIÓN FINAL
            </h2>
            <div className="space-y-4" data-id="element-8289">
              <p className="font-medium" data-id="element-8290">El restaurante declara que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/80" data-id="element-8291">
                <li data-id="element-8292">Ha leído este documento completo</li>
                <li data-id="element-8293">Comprende su alcance</li>
                <li data-id="element-8294">Acepta todas sus condiciones</li>
              </ul>
            </div>
          </section>
        </div>
      </main>
    </div>;
}